import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from '../../../configuration.service';
import { IBranding } from 'src/app/models/user';
import { BehaviorSubject } from 'rxjs';
import { IBrandingImportOptions } from '../../../http-models/branding/branding-http-request-model';
import { UploaderService } from '../../../../components/file-drop/uploader.service';
import { IUploader, UPLOADER_SERVICE_UNIQUE_IDS_ENUM } from '../../../../constants/shared/uploader-service-unique-ids';

@Injectable({
    providedIn: 'root',
})
export class BrandingAuthApiService implements IUploader {
    path = `${this.config.apiIP}/auth/branding/onboarding`;
    public readonly type = UPLOADER_SERVICE_UNIQUE_IDS_ENUM.BRANDING;
    private comapnyBranding = new BehaviorSubject<IBranding>(null);
    public comapnyBranding$ = this.comapnyBranding.asObservable();

    constructor(
        private http: HttpClient,
        private config: ConfigurationService,
        private uploaderService: UploaderService
    ) {}

    get() {
        return this.http.get(`${this.path}`);
    }

    updateProperty(propertyName, propertyValue) {
        return this.http.put(`${this.path}/property`, {
            propertyName: propertyName,
            proertyValue: propertyValue,
        });
    }

    async uploadLogoAsync(formData: FormData, updateBothLogos: boolean) {
        const httpRequest = this.http.post(`${this.path}/logo`, formData, {
            reportProgress: true,
            observe: 'events',
            params: { updateBothLogos: updateBothLogos },
        });
        return await this.uploaderService.uploadFileAsync(this.type, httpRequest);
    }
    uploadLogoW = (formData, extraParams = {}) => {
        return this.http.post(`${this.path}/logow`, formData, {
            reportProgress: true,
            observe: 'events',
            params: extraParams,
        });
    };
    import = (initial = true, domain = null, waitForAbout: boolean, to: IBrandingImportOptions) => {
        return this.http.put<{ branding: IBranding; isPlaceholderLogo: boolean }>(`${this.path}/import`, {
            initial: initial,
            domain: domain,
            waitForAbout,
            to: to,
        });
    };
    deleteLogo = (logoToDelete: 'logo' | 'logoW') => {
        return this.http.delete(`${this.path}/delete-logo`, {
            body: { logoToDelete }, // Send logoToDelete as a query parameter
        });
    };
    changeCompanyDemoBranding(branding: IBranding) {
        this.comapnyBranding.next(branding);
    }
}
